import type { PageContent } from '@/content/pages';
import { ProductWorkflow } from './ProductWorkflow';
import { TreasuryWorkflowMockup } from './TreasuryWorkflowMockup';

const STEP_LABELS = ['Accounts', 'Rules', 'Payment', 'Records'];

/** An automatically playing example of the four treasury tasks. */
export function TreasuryWorkflow({
  workflow,
}: {
  workflow: NonNullable<PageContent['workflow']>;
}) {
  return (
    <ProductWorkflow
      workflow={workflow}
      label="Treasury"
      shortLabels={STEP_LABELS}
      className="treasury-workflow"
      Mockup={TreasuryWorkflowMockup}
    />
  );
}
